<template>
  <div class="vuetify-alert">
    <v-alert v-bind="getAlertVOptions" :value="visible" @input="handleDismissible">
      <p class="text-body-1 mb-0" v-html="text"></p>
      <v-btn v-if="actionButtonFn" elevation="0" class="mt-2" @click="handleClickActionButton">
        {{ actionButtonText }}
      </v-btn>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'VuetifyAlert',
  props: {
    /**
     * https://vuetifyjs.com/en/components/alerts/#alerts
     */
    alertVOptions: {
      type: Object,
      default() {
        return {
          'close-icon': 'mdi-close-thick',
          dismissible: true,
          elevation: 5,
          icon: false
        }
      }
    },
    actionButtonFn: {
      type: Function,
      default() {
        return false
      }
    },
    actionButtonText: {
      type: String,
      default: 'Accept'
    },
    color: {
      type: String,
      default: ''
    },
    dismissibleTimeOut: {
      type: Number,
      default: 5000
    },
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'info'
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * Get alert Vuetify options
     *
     * @return {Object} - alert options
     */
    getAlertVOptions() {
      const customAlertVOptions = this.color ? { color: this.color } : { type: this.type }

      return {
        ...this.alertVOptions,
        ...customAlertVOptions
      }
    }
  },
  methods: {
    /**
     * Handle click on "dismissible" button. Event sent to parent
     *
     * @param {Boolean} value - hide or show
     */
    handleDismissible(value) {
      this.$emit('onDismissible', value)
    },
    /**
     * Handle click on "action" button. Event sent to parent
     *
     * @param {Object} $event - triggered event
     */
    handleClickActionButton($event) {
      this.$emit('onClickActionButton', $event)
    }
  }
}
</script>

<style lang="scss">
.vuetify-alert {
  position: fixed;
  z-index: 250; // por encima de appDialog pero por debajo de appLoading
  width: 60%;
  top: 10%;
  left: 50%;
  margin-left: -30%;
}
@media (max-width: 600px) {
  .vuetify-alert {
    top: auto;
    bottom: 0;
    left: 0;
    margin-left: 5%;
    width: 90%;
  }
}
</style>
